import { useRef, useState, useEffect } from "react";
import {
  Box,
  Grid,
  IconButton,
  Loading,
  Tooltip,
  Typography,
} from "../../components";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import { ThemeProvider } from "@mui/material/styles";
import lightTheme from "../../styles/light-theme";
import offlineTheme from "../../styles/offline-theme";
import "./pdv-style.scss";
import {
  BancosCaixasResponsaveisService,
  BancosCaixasService,
  CaixaService,
  ColaboradorService,
  CondicoesPagamentoService,
  ImpressoraService,
  MeioPagamentoService,
  MeioPagamentoLocalService,
  OperacoesFiscaisLocalService,
  ColaboradoresLocalService,
  NfSaidaService,
  OperacaoFiscalService,
  OrigemMercadoriaService,
  SessionService,
  UnidadeComercialService,
  history,
  notification,
  UnidadesComerciaisLocalService,
  CondicoesPagamentoLocalService,
  UsuariosLocalService,
  ClientesLocalService,
  ProdutosLocalService,
  NfSaidaLocalService,
  PdvOfflineLocalService,
  OrigensMercadoriasLocalService,
  SincService,
  TefHubService,
  TefService,
} from "../../services";
import { InputErros, PermissoesHelper, StorageHelper } from "../../helpers";
import {
  beforeUnload,
  formatDate,
  formatPrice,
  responseErros,
} from "../../utils";
import {
  CabecalhoPdv,
  IdentificarClienteDialog,
  InformacaoComplementarDialog,
  OperacoesCaixaDialog,
  ImportarPedidoPdvDialog,
  AtalhosDialog,
  PdvClienteView,
  PdvProdutoView,
  PdvTotalizadores,
  NotasCreditoDialog,
  SincronizacaoInicialDialog,
  HistoricoNfSaidaDialog,
  NomePdvOfflineDialog,
  ValidarPermissaoDialog,
} from "./components";
import ConfiguracoesBalancaDialog from "./components/dialog/configuracoes-balanca-dialog.component";
import { NfSaida, NfSaidaItem, NfSaidaItemCancelado } from "../../entities";
import { nfSaidaValidator } from "./middlewares";
import shortid from "shortid";
import Mousetrap from "mousetrap";
import {
  getListaPagamentoPadrao,
  verificaBaixaAutomatica,
  normalizarQuantidade,
} from "../../entities/pdv";
import {
  generateDanfeNfceContigencia,
  generateDanfeNfceSecundaria,
  generateComprovanteDebito,
  DATATYPE_TEF,
  limitesVenda,
} from "../../resources";
import { stringsSucessoMensagemTef } from "../../resources/constantes";

const sessionService = new SessionService();
const caixaService = new CaixaService();
const unidadeComercialService = new UnidadeComercialService();
const origemMercadoriaService = new OrigemMercadoriaService();
const meioPagamentoService = new MeioPagamentoService();
const condicoesPagamentoService = new CondicoesPagamentoService();
const operacaoFiscalService = new OperacaoFiscalService();
const bancosCaixasService = new BancosCaixasService();
const nfSaidaService = new NfSaidaService();
const bancosCaixasResponsaveisService = new BancosCaixasResponsaveisService();
const colaboradorService = new ColaboradorService();
const impressoraService = new ImpressoraService();
const sincService = new SincService();
const tefHubService = new TefHubService();

const novaNfSaidaPdv = () =>
  new NfSaida({
    dataEmissao: formatDate.toSend(new Date()),
    modalidadeFrete: "mfSemFrete",
    freteCompoeNota: false,
  });

let pdvEntity = novaNfSaidaPdv();
let lockPdvAba = null;

function adquirirLockPdvAba() {
  if (!navigator.locks) return Promise.resolve(true);
  if (!lockPdvAba) {
    lockPdvAba = new Promise((resolve) => {
      navigator.locks.request(
        "siaf-lite-pdv",
        { ifAvailable: true },
        (lock) => {
          resolve(Boolean(lock));
          return lock ? new Promise(() => {}) : null;
        },
      );
    }).then((adquirido) => {
      if (!adquirido) lockPdvAba = null;
      return adquirido;
    });
  }
  return lockPdvAba;
}

const PdvView = () => {
  const apiRef = useGridApiRef();
  const gridRef = useRef();
  const [loading, setLoading] = useState(false);
  const [bancoCaixa, setBancoCaixa] = useState(null);
  const [operacaoFiscalList, setOperacaoFiscalList] = useState([]);
  const [operacaoFiscal, setOperacaoFiscal] = useState({});
  const [operacaoFiscalSecundaria, setOperacaoFiscalSecundaria] = useState({});
  const [venda, setVenda] = useState(pdvEntity);
  const [produto, setProduto] = useState(null);
  const [item, setItem] = useState({});
  const [isProdutoEdit, setIsProdutoEdit] = useState(false);
  const [listaProdutos, setListaProdutos] = useState([]);
  const [vendedorList, setVendedorList] = useState([]);
  const [meioPagamentoList, setMeioPagamentoList] = useState([]);
  const [condicaoPagamentoList, setCondicaoPagamentoList] = useState([]);
  const [listaNfSaida, setListaNfSaida] = useState([]);
  const [nfSaidaRowCount, setNfSaidaRowCount] = useState(0);
  const [clienteList, setClienteList] = useState([]);
  const [condicaoSelecionada, setCondicaoSelecionada] = useState(null);
  const [unidadeList, setUnidadeList] = useState([]);
  const [origensMercadoriasList, setOrigensMercadoriasList] = useState([]);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [dataAberturaCaixa, setDataAberturaCaixa] = useState(null);
  const [listaProdutosVenda, setListaProdutosVenda] = useState([]);
  const [listaProdutosSimilares, setListaProdutosSimilares] = useState([]);
  const [listaPagamentosVenda, setListaPagamentosVenda] = useState([]);
  const [pagamentoSelecionado, setPagamentoSelecionado] = useState(null);
  const [userLog, setUserLog] = useState({});
  const [configuracoes, setConfiguracoes] = useState(null);
  const [dadosImpressao, setDadosImpressao] = useState(null);
  const [anchorEmpresas, setAnchorEmpresas] = useState(null);
  const [tefConnection, setTefConnection] = useState(null);
  const [dadosMenuTef, setDadosMenuTef] = useState({});
  const [openDialogPagamentos, setOpenDialogPagamentos] = useState(false);
  const [openDialogIdentificarCliente, setOpenDialogIdentificarCliente] =
    useState(false);
  const [openDialogHistoricoNfSaida, setOpenDialogHistoricoNfSaida] =
    useState(false);
  const [openDialogOperacoesCaixa, setOpenDialogOperacoesCaixa] =
    useState(false);
  const [openDialogListaPagamentos, setOpenDialogListaPagamentos] =
    useState(false);
  const [openImportarPedidoDialog, setOpenImportarPedidoDialog] =
    useState(false);
  const [openAtalhosDialog, setOpenAtalhosDialog] = useState(false);
  const [openConfiguracaoBalancaDialog, setOpenConfiguracaoBalancaDialog] =
    useState(false);
  const [openDialogAdministracaoTef, setOpenDialogAdministracaoTef] =
    useState(false);
  const [mudarUsuario, setMudarUsuario] = useState(false);
  const { empresa: dadosEmpresa, usuario: dadosUsuario } =
    sessionService.getEmpresaAndUsuario();
  const empresaImpressao = sessionService.getEmpresaRelatorio();
  const [listaPagamentoPadrao, setListaPagamentoPadrao] = useState([]);
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const [
    openDialogInformacaoComplementar,
    setOpenDialogInformacaoComplementar,
  ] = useState(false);
  const [notasCredito, setNotasCredito] = useState([]);
  const [listaNotasCredito, setListaNotasCredito] = useState([]);
  const [openNotasCreditoDialog, setOpenNotasCreditoDialog] = useState(false);
  const [meioPagamentoCredito, setMeioPagamentoCredito] = useState({});
  const [colaboradorVendedor, setColaboradorVendedor] = useState(null);
  const [openDialogSincronizacaoInicial, setOpenDialogSincronizacaoInicial] =
    useState(false);
  const [tempoRestanteSincronizacao, setTempoRestanteSincronizacao] =
    useState(120);
  const [configuracoesTef, setConfiguracoesTef] = useState({});
  const [openDialogNomePdvOffline, setOpenDialogNomePdvOffline] =
    useState(false);
  const [dialogPermissao, setDialogPermissao] = useState({ open: false });
  const [pdvAbertoOutraAba, setPdvAbertoOutraAba] = useState(false);
  const [atalhos, setAtalhos] = useState([
    { atalho: "F1", nome: "AJUDA" },
    { atalho: "F4", nome: "BUSCAR PRODUTO" },
    { atalho: "Ctrl + I", nome: "IDENTIFICAR CLIENTE" },
    { atalho: "Ctrl + O", nome: "OPERAÇÕES CAIXA" },
    { atalho: "Ctrl + P", nome: "LISTA DE PAGAMENTOS" },
    { atalho: "Ctrl + Alt + F11", nome: "FINALIZAR VENDA SECUNDÁRIA" },
    { atalho: "Ctrl + Alt + F12", nome: "FINALIZAR VENDA PRIMÁRIA" },
    { atalho: "Ctrl + Alt + Enter", nome: "FINALIZAR VENDA" },
    { atalho: "Ctrl + Alt + C", nome: "LIMPAR CARRINHO" },
    { atalho: "Ctrl + Alt + B", nome: "CONFIGURAR BALANÇA" },
  ]);
  const [pdvOnLine, setPdvOnLine] = useState(true);
  const nfSaidaValidatorService = nfSaidaValidator(operacaoFiscal);
  const UNAUTHORIZED = 401;
  const pdvOnLineStorage = sessionService.getDadosOffline();
  const market = "https://public.siafevolution.com.br/supermarket.gif";
  const dadosImpressaoRef = useRef(dadosImpressao);
  const sincronizacaoInicialTimeoutRef = useRef(null);
  const sincronizacaoInicialIntervalRef = useRef(null);
  const permissoesHelper = new PermissoesHelper();
  const storageHelper = new StorageHelper();
  const chaveVendaEmAndamento = `pdv-venda-em-andamento-${dadosEmpresa?.id}`;
  const pdvIniciadoRef = useRef(false);
  const vendaGravadaRef = useRef(false);
  const salvarVendaEmAndamentoRef = useRef(null);

  beforeUnload((event) => {
    salvarVendaEmAndamento();
    if (existeVendaEmAndamento()) {
      event.preventDefault();
      event.returnValue = "";
    }
  });

  useEffect(() => {
    salvarVendaEmAndamentoRef.current = salvarVendaEmAndamento;
  });

  useEffect(() => {
    dadosImpressaoRef.current = dadosImpressao;
  }, [dadosImpressao]);

  useEffect(() => {
    iniciarPdv();
    return () => salvarVendaEmAndamentoRef.current?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    salvarVendaEmAndamento();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    listaProdutosVenda,
    listaPagamentosVenda,
    clienteSelecionado,
    operacaoFiscal,
  ]);

  useEffect(() => {
    if (!pdvOnLine) {
      notification.alertaGenericos("Você está no modo offline");
    }
  }, [pdvOnLine]);

  useEffect(() => {
    notification.setModoOffline(!pdvOnLine);
    document.body.classList.toggle("pdv-modo-offline", !pdvOnLine);
    return () => {
      notification.setModoOffline(false);
      document.body.classList.remove("pdv-modo-offline");
    };
  }, [pdvOnLine]);

  async function iniciarPdv() {
    if (!storageHelper.getLocal("token")) {
      history.push("/login");
      return;
    }
    if (!(await adquirirLockPdvAba())) {
      Mousetrap.reset();
      setPdvAbertoOutraAba(true);
      return;
    }
    restaurarVendaEmAndamento(buscarVendaEmAndamento());
    validarStatusPdvOnLine();
  }

  function existeVendaEmAndamento() {
    return Boolean(pdvEntity.nfSaidaItens?.length) && !vendaGravadaRef.current;
  }

  function buscarVendaEmAndamento() {
    if (!dadosEmpresa?.id) return null;
    try {
      const vendaSalva = JSON.parse(
        storageHelper.getLocal(chaveVendaEmAndamento),
      );
      return vendaSalva?.venda?.nfSaidaItens?.length &&
        vendaSalva.listaProdutosVenda?.length
        ? vendaSalva
        : null;
    } catch (error) {
      return null;
    }
  }

  function restaurarVendaEmAndamento(vendaSalva) {
    pdvIniciadoRef.current = true;
    if (!vendaSalva) {
      pdvEntity = novaNfSaidaPdv();
      setVenda(pdvEntity);
      return;
    }
    const listaPagamentos = (vendaSalva.listaPagamentosVenda ?? []).map(
      (pagamento) => ({
        ...pagamento,
        dataVencimento: new Date(pagamento.dataVencimento),
      }),
    );
    pdvEntity = Object.assign(novaNfSaidaPdv(), vendaSalva.venda, {
      dataEmissao: formatDate.toSend(new Date()),
    });
    pdvEntity.setChangePagamentos(listaPagamentos);
    if (vendaSalva.operacaoFiscal?.id) {
      pdvEntity.setOperacaoFiscal(vendaSalva.operacaoFiscal);
      setOperacaoFiscal(vendaSalva.operacaoFiscal);
    }
    setVenda(pdvEntity);
    setListaProdutosVenda(vendaSalva.listaProdutosVenda);
    setListaPagamentosVenda(listaPagamentos);
    setClienteSelecionado(vendaSalva.clienteSelecionado ?? null);
    notification.alertaGenericos(
      "Venda em andamento recuperada. Grave a venda ou limpe o carrinho para continuar",
    );
  }

  function salvarVendaEmAndamento() {
    if (!pdvIniciadoRef.current || !dadosEmpresa?.id) return;
    if (!existeVendaEmAndamento()) {
      removerVendaEmAndamento();
      return;
    }
    try {
      storageHelper.setLocal(
        chaveVendaEmAndamento,
        JSON.stringify({
          venda: pdvEntity,
          listaProdutosVenda,
          listaPagamentosVenda,
          clienteSelecionado,
          operacaoFiscal,
        }),
      );
    } catch (error) {
      console.error("Erro ao salvar venda em andamento:", error);
    }
  }

  function removerVendaEmAndamento() {
    storageHelper.removeLocal(chaveVendaEmAndamento);
  }

  function marcarVendaGravada() {
    vendaGravadaRef.current = true;
    removerVendaEmAndamento();
  }

  function validarStatusPdvOnLine() {
    let onLine = true;
    if (pdvOnLineStorage) {
      if (dadosEmpresa.modoOfflinePdv) {
        carregarServicesOffLine();
        carregarLogoEmpresaOffline();
        if (!pdvOnLineStorage.pdvOnLine) {
          onLine = false;
          setPdvOnLine(onLine);
        } else {
          nfSaidasSincronizacaoPendentes();
        }
      } else {
        limparModuloPdvOffline();
      }
    }
    buscarDadosIniciais(onLine);
  }

  async function carregarLogoEmpresaOffline() {
    const urlLogo = dadosEmpresa.imagemLogo;
    if (!urlLogo || urlLogo.startsWith("data:")) return;
    const imagemLogoBase64 = await converterBlobParaBase64(urlLogo);
    if (!imagemLogoBase64) return;
    const dadosOffline = sessionService.getDadosOffline();
    sessionService.setDadosOffline({
      ...dadosOffline,
      imagemLogoBase64: imagemLogoBase64,
    });
    return imagemLogoBase64;
  }

  async function converterBlobParaBase64(imageLogo) {
    const response = await fetch(imageLogo);
    if (!response.ok) {
      throw new Error("Erro ao baixar logo da empresa");
    }
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.onloadend = () => resolve(fileReader.result);
      fileReader.onerror = reject;
      fileReader.readAsDataURL(blob);
    });
  }

  async function nfSaidasSincronizacaoPendentes() {
    const sincronizacaoPendentes = storageHelper.getLocal(
      "nf-saidas-sincronizacao-pendente",
    );
    if (sincronizacaoPendentes) {
      await sincService.sincronizarNfSaida();
      storageHelper.setLocal("nf-saidas-sincronizacao-pendente", false);
    }
  }

  function limparModuloPdvOffline() {
    if (dadosEmpresa?.id) {
      MeioPagamentoLocalService.deletarDatabase(dadosEmpresa.id);
      ColaboradoresLocalService.deletarDatabase(dadosEmpresa.id);
      OperacoesFiscaisLocalService.deletarDatabase(dadosEmpresa.id);
      UnidadesComerciaisLocalService.deletarDatabase();
      OrigensMercadoriasLocalService.deletarDatabase();
      CondicoesPagamentoLocalService.deletarDatabase(dadosEmpresa.id);
      ClientesLocalService.deletarDatabase(dadosEmpresa.id);
      ProdutosLocalService.deletarDatabase(dadosEmpresa.id);
      UsuariosLocalService.deletarDatabase(dadosEmpresa.id);
      NfSaidaLocalService.deletarDatabase(dadosEmpresa.id);
      PdvOfflineLocalService.deletarDatabase(dadosEmpresa.id);
    }
  }

  function carregarServicesOffLine() {
    if (dadosEmpresa?.id && !pdvOnLineStorage.sincronizacaoInicial) {
      startSincronizacaoOffline();
    } else {
      abrirDialogoNomePdvOffline();
    }
  }

  function startSincronizacaoOffline() {
    MeioPagamentoLocalService.startSincronizacao(dadosEmpresa.id);
    ColaboradoresLocalService.startSincronizacao(dadosEmpresa.id);
    OperacoesFiscaisLocalService.startSincronizacao(dadosEmpresa.id);
    UnidadesComerciaisLocalService.startSincronizacao();
    OrigensMercadoriasLocalService.startSincronizacao();
    CondicoesPagamentoLocalService.startSincronizacao(dadosEmpresa.id);
    UsuariosLocalService.startSincronizacao(dadosEmpresa.id);
    ProdutosLocalService.startSincronizacao(dadosEmpresa.id);
    ClientesLocalService.startSincronizacao(dadosEmpresa.id);
    NfSaidaLocalService.startSincronizacao(dadosEmpresa.id);
    PdvOfflineLocalService.startSincronizacao(dadosEmpresa.id);
  }

  function abrirDialogoNomePdvOffline() {
    setOpenDialogNomePdvOffline(true);
  }

  function startSincronizacaoInicialOffline() {
    if (sincronizacaoInicialTimeoutRef.current) {
      return;
    }
    setOpenDialogSincronizacaoInicial(true);
    setTempoRestanteSincronizacao(120);
    let tempoDecorrido = 0;
    sincronizacaoInicialIntervalRef.current = setInterval(() => {
      tempoDecorrido += 1;
      const tempoRestante = 120 - tempoDecorrido;
      setTempoRestanteSincronizacao(tempoRestante);

      if (tempoRestante <= 0) {
        setOpenDialogSincronizacaoInicial(false);
        clearInterval(sincronizacaoInicialIntervalRef.current);
        sincronizacaoInicialIntervalRef.current = null;
      }
    }, 1000);
    sincronizacaoInicialTimeoutRef.current = setTimeout(() => {
      sessionService.setSincronizacaoInicial(false);
      startSincronizacaoOffline();
    }, 60000);
  }

  const scrollToBottom = () => {
    const scroller = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller",
    );
    if (scroller?.length) {
      setTimeout(() => {
        scroller[0].scrollTop = scroller[0].scrollHeight;
      }, 100);
    }
  };

  useEffect(() => {
    if (listaProdutosVenda?.length) scrollToBottom();
  }, [listaProdutosVenda]);

  const dadosProdutosColunas = [
    {
      field: "codigo",
      headerName: "Cod",
      flex: 150,
      headerClassName: "table-pdv-header",
      sortable: false,
    },
    {
      field: "descricao",
      headerName: "Descrição",
      flex: 600,
      headerClassName: "table-pdv-header",
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="my-2">
            <Typography variant="h6" style={{ fontWeight: 600 }}>
              {params.value}
            </Typography>
            <span
              style={{
                fontWeight: 400,
                fontSize: "0.75rem",
                lineHeight: "normal",
              }}
            >
              Qtd: {formatQuantidadeGrid(params.row?.quantidade)} UNID X
              Vl.Unit: {formatPrice(params.row?.valor)} | Desc:{" "}
              {formatPrice(params.row?.desconto || 0)} | Acrésc:{" "}
              {formatPrice(params.row?.despesas || 0)} | Est:{" "}
              {params.row?.codigoBarra}
            </span>
          </div>
        );
      },
    },
    {
      field: "subtotal",
      headerName: "Total",
      headerClassName: "table-pdv-header",
      flex: 150,
      sortable: false,
      valueGetter: (params) => formatPrice(params.value),
    },
    {
      field: "acoes",
      headerName: "Ações",
      sortable: false,
      headerClassName: "table-pdv-header",
      flex: 150,
      disableClickEventBubbling: true,
      hideable: false,
      renderCell: (params) => {
        return (
          <div>
            <IconButton
              onClick={() => {
                handleEditarProduto(params.id);
              }}
            >
              <Tooltip title="Editar" arrow placement="right">
                <i className="ph-fill ph-pencil" style={{ fontSize: 18 }}></i>
              </Tooltip>
            </IconButton>
            <IconButton
              onClick={(event) => {
                event.stopPropagation();
                handleRemoverProduto(params.id);
              }}
            >
              <Tooltip title="Excluir" arrow placement="right">
                <i className="ph-fill ph-trash" style={{ fontSize: 18 }}></i>
              </Tooltip>
            </IconButton>
          </div>
        );
      },
    },
  ];

  const atalhosPdv = [
    {
      keys: ["ctrl+i", "command+i"],
      action: () => {
        identificarCliente();
        return false;
      },
    },
    {
      keys: ["ctrl+o", "command+o"],
      action: () => {
        setOpenDialogOperacoesCaixa(true);
        return false;
      },
    },
    {
      keys: ["ctrl+p", "command+p"],
      action: (e) => {
        e.preventDefault();
        setOpenDialogListaPagamentos(true);
        return false;
      },
    },
    {
      keys: ["ctrl+alt+t", "command+alt+t"],
      action: (e) => {
        e.preventDefault();
        abrirDialogAdministracaoTef();
        return false;
      },
    },
    {
      keys: ["f1"],
      action: () => {
        setOpenAtalhosDialog(true);
        return false;
      },
    },
    {
      keys: ["f4"],
      action: (e) => {
        e.preventDefault();
        document.getElementById("produtoId").focus();
        return false;
      },
    },
    {
      keys: ["ctrl+alt+f11", "command+option+f11"],
      action: (e) => {
        e.preventDefault();
        handleSubmit(false);
        return false;
      },
    },
    {
      keys: ["ctrl+alt+f12", "command+option+f12"],
      action: (e) => {
        e.preventDefault();
        handleSubmit();
        return false;
      },
    },
    {
      keys: ["ctrl+alt+c", "₢", "command+option+c"],
      action: () => {
        limparPdvAtalho();
        return false;
      },
    },
    {
      keys: ["ctrl+alt+b", "command+option+b"],
      action: (e) => {
        e.preventDefault();
        setOpenConfiguracaoBalancaDialog(true);
        return false;
      },
    },
    {
      keys: [
        "ctrl+alt+1",
        "command+option+1",
        "ctrl+alt+2",
        "command+option+2",
        "ctrl+alt+3",
        "command+option+3",
        "ctrl+alt+4",
        "command+option+4",
        "ctrl+alt+5",
        "command+option+5",
      ],
      action: (_, combo) => {
        const keyCommand = combo.replace(/[^0-9]/g, "");
        document.getElementById(`meio-pagamento-${keyCommand}`)?.click();
        return false;
      },
    },
    {
      keys: [
        "f5",
        "ctrl+f5",
        "ctrl+r",
        "ctrl+shift+r",
        "command+r",
        "command+shift+r",
      ],
      action: () => {
        if (bloqueadoPorVendaEmAndamento("recarregar a página")) return false;
      },
    },
  ];

  if (!pdvAbertoOutraAba) {
    atalhosPdv.map(({ keys, action }) => Mousetrap.bind(keys, action));
  }

  Mousetrap.stopCallback = function () {
    return false;
  };

  const handleFecharMenuEmpresas = () => {
    setAnchorEmpresas(null);
  };

  const abrirDialogAdministracaoTef = async () => {
    handleFecharMenuEmpresas();
    const tefConnection = new TefService();
    setTefConnection(tefConnection);
    setLoading(true);

    try {
      await tefConnection.connect();
    } catch (error) {
      setLoading(false);
      notification.erroInternoServidor();
      console.log("Falhou a conexão com signalr =>", error?.toString());
      return;
    }

    tefConnection.onInicializaTef(() => {
      console.log("Inicializa Tef...");
      setOpenDialogAdministracaoTef(true);
      setLoading(false);
    });

    tefConnection.onMontaMenuTef(async (payload) => {
      console.log("Monta Menu Tef", payload);
      const tituloSplit = payload?.titulo?.split(" - ");
      const titulo = tituloSplit?.[1]?.length ? tituloSplit[1] : tituloSplit;

      if (payload?.dataType === DATATYPE_TEF.AWAIT) {
        if (
          stringsSucessoMensagemTef.some((item) =>
            payload?.mensagem.toLowerCase().includes(item),
          )
        ) {
          notification.sucessoGenericos(payload?.mensagem);
        } else {
          notification.alertaGenericos(payload?.mensagem);
        }
      } else if (payload?.dataType === DATATYPE_TEF.INFORMATION) {
        notification.alertaGenericos(payload?.mensagem);
        await tefConnection.disconnect();
        setOpenDialogAdministracaoTef(false);
        setDadosMenuTef(null);
      } else {
        setDadosMenuTef((prev) => ({
          ...prev,
          ...payload,
          titulo,
          itensMenu: payload?.itensMenu?.filter((item) => item !== ""),
        }));
      }
    });

    tefConnection.onExibeMensagemTef(async (mensagem) => {
      console.log("signalr.onExibeMensagemTef", { mensagem });
      if (mensagem.includes("Erro -")) {
        await tefConnection.disconnect();
        setOpenDialogAdministracaoTef(false);
        setDadosMenuTef(null);
      } else {
        setDadosMenuTef((prev) => ({
          mensagem,
          qrCode: prev?.qrCode,
          dataType: prev?.qrCode ? prev.dataType : null,
        }));
      }
    });

    tefConnection.onExibeQRCodeTef((payload) => {
      console.log("signalr.onExibeQRCodeTef", payload);
      setDadosMenuTef((prev) => ({
        ...payload,
        mensagem: prev.mensagem,
        qrCode: payload.mensagem,
      }));
    });

    tefConnection.onFinalizacaoTef(async (payload) => {
      console.log("signalr.onFinalizacaoTef", payload);
      if (
        payload?.comprovanteCliente?.length ||
        payload?.comprovanteEstab?.length
      ) {
        const result = await tefHubService.imprimirComprovante(payload);
        if (!result.isAxiosError) {
          notification.sucessoGenericos("Impressão do comprovante concluída!");
        } else {
          responseErros(result);
        }
      }
      if (payload?.mensagem) {
        notification.alertaGenericos(payload?.mensagem);
      }
      await tefConnection.disconnect();
      setLoading(false);
      setOpenDialogAdministracaoTef(false);
      setDadosMenuTef(null);
    });

    tefConnection.onMensagemTef(async (mensagem) => {
      console.log("signalr.onMensagemTef", mensagem);
      if (
        ["cancelada", "falha", "erro", "sem comunicação"].some((item) =>
          mensagem.toLowerCase().includes(item),
        )
      ) {
        await tefConnection.disconnect();
        setOpenDialogAdministracaoTef(false);
        setDadosMenuTef({});
        notification.erroGenericos(mensagem);
      }
    });

    tefConnection.onReconnecting((error) => {
      console.log("Conexão perdida, tentando reconectar...");
      notification.alertaGenericos("Tentando reconexão com o servidor");
      setLoading(true);
      if (error) console.error("Motivo:", error);
    });

    const handleCloseConnection = () => {
      setLoading(false);
      setOpenDialogAdministracaoTef(false);
      setDadosMenuTef({});
      notification.alertaGenericos("Erro de comunicação! Tente novamente");
    };

    tefConnection.onReconnected(async () => {
      console.log("Reconectado com sucesso!");
      await tefConnection.disconnect();
      handleCloseConnection();
    });

    tefConnection.onClose(() => {
      console.log("Conexão perdida. Tentando reconectar...");
      handleCloseConnection();
    });

    try {
      await tefConnection.invokeInicializaTef();
    } catch (error) {
      console.error("Erro no invokeInicializaTef:", error);
      setOpenDialogAdministracaoTef(true);
      setLoading(false);
      notification.erroGenericos(error?.message ?? "Erro ao inicializar TEF");
      await tefConnection.disconnect();
    }

    await tefConnection.invokeAdministracaoTef();
  };

  function formatQuantidadeGrid(number) {
    const numberString = number.toString();

    let casasDecimais = 0;
    if (numberString.includes(".")) {
      casasDecimais = numberString.split(".")[1].length;
    }
    if (casasDecimais === 0) {
      casasDecimais = 2;
    } else if (casasDecimais > 3) {
      casasDecimais = 3;
    }

    return number.toLocaleString("pt-BR", {
      minimumFractionDigits: casasDecimais,
      maximumFractionDigits: casasDecimais,
    });
  }

  function identificarCliente() {
    document.getElementsByTagName("body")[0].focus();
    setOpenDialogIdentificarCliente(true);
  }

  const handleLogout = async () => {
    if (bloqueadoPorVendaEmAndamento("sair")) return;
    if (!mudarUsuario) {
      notification
        .confirmacao("Tem certeza que deseja sair?")
        .then(async (result) => {
          if (result.value === true) {
            handleLogoutAlterarUsuario();
            validarToken();
          }
        });
    } else handleLogoutAlterarUsuario();
    setMudarUsuario(false);
  };

  const handleLogoutAlterarUsuario = async () => {
    setBancoCaixa(null);
    setListaProdutosVenda([]);
    storageHelper.removeLocal("token");
    storageHelper.removeLocal("rotinas");
    storageHelper.removeLocal("dados");
    storageHelper.removeSession("notificacao");
    storageHelper.removeLocal("bancoCaixaIdPdv");
  };

  const validarToken = async () => {
    const token = storageHelper.getLocal("token");
    if (!token) {
      history.push("/login");
      return;
    }
  };

  const abrirCaixa = async (bancoCaixaId) => {
    setLoading(true);
    const resultCaixa = await caixaService.cadastrar({
      data: new Date(),
      bancoCaixaId,
      aberto: true,
    });
    setLoading(false);
    if (resultCaixa.isAxiosError) {
      if (resultCaixa.response?.status === UNAUTHORIZED) {
        validarToken();
      } else {
        responseErros(resultCaixa);
      }
      return;
    }
    setDataAberturaCaixa(formatDate.toSend(new Date()));
    buscarBancoCaixa(bancoCaixaId);
  };

  const buscarBancoCaixaResponsavel = async () => {
    setLoading(true);
    const user = await sessionService.getUsuario();
    const result = await bancosCaixasResponsaveisService.getAll();
    if (!result.isAxiosError) {
      const data = result.data.rows.filter(
        (bancoCaixaResponsavel) =>
          bancoCaixaResponsavel?.usuarioId === user?.id &&
          bancoCaixaResponsavel?.bancoCaixa?.ativado === true,
      );
      if (data?.length) {
        abrirCaixa(data[0]?.bancoCaixaId);
      } else
        notification.alertaGenericos(
          "Você não tem acesso a nenhum caixa. Entre em contato com o administrador do sistema",
        );
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const buscarBancoCaixa = (bancoCaixaId) => {
    if (bancoCaixaId) {
      bancosCaixasService.getById(bancoCaixaId).then((result) => {
        if (result.isAxiosError) {
          if (result?.response?.status === UNAUTHORIZED) {
            validarToken();
          } else {
            responseErros(result);
          }
          return;
        }
        setBancoCaixa(result.data);
      });
    }
  };

  const buscarUnidadesComerciais = async () => {
    const filtros = {
      nonPaginated: true,
    };
    unidadeComercialService.getAll(filtros).then((result) => {
      if (!result.isAxiosError) {
        setUnidadeList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarUnidadesComerciaisOffLine = () => {
    UnidadesComerciaisLocalService.getAll().then((unidades) => {
      setUnidadeList(unidades);
    });
  };

  function buscarNfSaidaOffLine() {
    NfSaidaLocalService.getAll(
      {},
      { orderBy: "updatedAt", ordem: "desc", limite: 200 },
    ).then((nfSaidaList) => {
      setListaNfSaida(nfSaidaList);
      setNfSaidaRowCount(nfSaidaList.length);
    });
  }

  const buscarOrigensMercadoriaOffLine = () => {
    OrigensMercadoriasLocalService.getAll().then((origens) => {
      setOrigensMercadoriasList(origens);
    });
  };

  const buscarOrigensMercadoria = () => {
    origemMercadoriaService.getAll().then((res) => {
      if (!res.isAxiosError) {
        setOrigensMercadoriasList(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarConfiguracao = async () => {
    if (dadosEmpresa?.configuracoes) {
      const data = dadosEmpresa.configuracoes;
      setConfiguracoes(data);
      // if (data.operacaoFiscalPdvSecundariaId) {
      //   buscarOperacaoFiscalId(
      //     data.operacaoFiscalPdvSecundariaId,
      //     setOperacaoFiscalSecundaria,
      //     false,
      //   );
      // }
      // if (data?.operacaoFiscalPdvPadraoId) {
      //   await buscarOperacaoFiscalId(
      //     data.operacaoFiscalPdvPadraoId,
      //     setOperacaoFiscal,
      //   );
      // }
      return data;
    }
  };

  function filtrarOperacoesFiscaisPadraoSecundaria(
    operacoesFiscais,
    configuracoesEmpresa,
  ) {
    const operacaoSecundaria = operacoesFiscais.find(
      (operacaoFiscal) =>
        operacaoFiscal.id ===
        configuracoesEmpresa.operacaoFiscalPdvSecundariaId,
    );
    setOperacaoFiscalSecundaria(operacaoSecundaria);

    const operacaoVendaEmAndamento =
      pdvEntity.nfSaidaItens?.length &&
      operacoesFiscais.find(
        (operacaoFiscal) => operacaoFiscal.id === pdvEntity.operacaoFiscalId,
      );
    if (operacaoVendaEmAndamento) {
      setOperacaoFiscal(operacaoVendaEmAndamento);
      return;
    }

    if (configuracoesEmpresa?.operacaoFiscalPdvPadraoId) {
      const operacaoPadrao = operacoesFiscais.find(
        (operacaoFiscal) =>
          operacaoFiscal.id === configuracoesEmpresa.operacaoFiscalPdvPadraoId,
      );
      setOperacaoFiscal(operacaoPadrao);
      pdvEntity.setOperacaoFiscal(operacaoPadrao);
      setVenda(pdvEntity);
    } else if (configuracoesEmpresa?.operacaoFiscalPdvSecundariaId) {
      setOperacaoFiscal(operacaoSecundaria);
    }
  }

  // const buscarOperacaoFiscalId = async (
  //   id,
  //   setOperacaoFiscal,
  //   operacaoPadrao = true,
  // ) => {
  //   if (id) {
  //     operacaoFiscalService.getById(id).then((result) => {
  //       if (!result.isAxiosError) {
  //         setOperacaoFiscal(result.data);
  //         if (operacaoPadrao) {
  //           pdvEntity.setOperacaoFiscal(result.data);
  //           setVenda(pdvEntity);
  //         }
  //       } else {
  //         responseErros(result);
  //       }
  //     });
  //   }
  // };

  function buscarNfSaida(filtros) {
    nfSaidaService.getAll(filtros).then((result) => {
      if (!result.isAxiosError) {
        setListaNfSaida(result.data.rows);
        setNfSaidaRowCount(result.data.count);
      } else {
        responseErros(result);
      }
    });
  }

  const buscarOperacoesFiscais = async (configuracoesEmpresa) => {
    const filtrosOperacoesFiscais = {
      ativado: true,
      nonPaginated: true,
      // tipoOperacao: "SAIDA",
      // finalidade: ["NAO_SE_APLICA", "NFE_NORMAL"],
      // modeloDocumento: ["65", "01"],
      restritiva: true,
      porIntervalo: [],
    };
    operacaoFiscalService
      .getAllFiltroAvancado(filtrosOperacoesFiscais)
      .then((result) => {
        if (!result.isAxiosError) {
          filtraOperacoesFiscal(result.data);
          filtrarOperacoesFiscaisPadraoSecundaria(
            result.data,
            configuracoesEmpresa,
          );
        } else {
          responseErros(result);
        }
      });
  };

  function filtraOperacoesFiscal(operacoesFiscais) {
    setOperacaoFiscalList(
      operacoesFiscais.filter(
        (operacaoFiscal) =>
          operacaoFiscal.tipoOperacao === "SAIDA" &&
          (operacaoFiscal.modeloDocumento === "65" ||
            operacaoFiscal.modeloDocumento === "01") &&
          (operacaoFiscal.finalidade === "NAO_SE_APLICA" ||
            operacaoFiscal.finalidade === "NFE_NORMAL"),
      ),
    );
  }

  const buscarOperacoesFiscaisOffLine = async (configuracoesEmpresa) => {
    const operacoes = await OperacoesFiscaisLocalService.getAll();
    filtraOperacoesFiscal(operacoes);
    filtrarOperacoesFiscaisPadraoSecundaria(operacoes, configuracoesEmpresa);
  };

  const buscarMeiosPagamentos = async function () {
    const filtros = {
      ativado: true,
      nonPaginated: true,
    };
    const result = await meioPagamentoService.getAll(filtros);
    if (!result.isAxiosError) {
      setMeioPagamentoList(
        result.data.filter(
          (meio) =>
            meio.disponivelPdv || meio.nfePagamento === "fpCreditoEmLoja",
        ),
      );
      setMeioPagamentoCredito(
        result.data.find((meio) => meio.nfePagamento === "fpCreditoEmLoja"),
      );
      return result.data;
    } else {
      if (result.response?.status === UNAUTHORIZED) {
        validarToken();
      } else {
        responseErros(result);
      }
    }
  };

  const buscarMeiosPagamentosOffLine = async function () {
    const meios = await MeioPagamentoLocalService.getAll();
    const meiosFiltrados = meios.filter(
      (meio) => meio.disponivelPdv || meio.nfePagamento === "fpCreditoEmLoja",
    );
    setMeioPagamentoList(meiosFiltrados);
    const meioCredito = meios.find(
      (meio) => meio.nfePagamento === "fpCreditoEmLoja",
    );
    setMeioPagamentoCredito(meioCredito);
    return meios;
  };

  const buscarCondicoesPagamentos = () => {
    const filtros = {
      nonPaginated: true,
      ativado: true,
    };
    condicoesPagamentoService.getAll(filtros).then((result) => {
      if (!result.isAxiosError) {
        setCondicaoPagamentoList(result.data);
      } else {
        if (result?.response?.status === UNAUTHORIZED) {
          validarToken();
        } else {
          responseErros(result);
        }
      }
    });
  };

  const buscarCondicoesPagamentosOffLine = async () => {
    const condicoes = await CondicoesPagamentoLocalService.getAll(
      {},
      { where: { ativado: true } },
    );
    setCondicaoPagamentoList(condicoes);
  };

  const buscarClienteOffLine = async (filtros, setClienteList) => {
    const clientes = await ClientesLocalService.getAll(filtros, {
      modo: "or",
      where: { ativado: true },
      orderBy: "nomeRazaoSocial",
      limite: 50,
    });
    setClienteList(clientes.filter((cliente) => cliente.ativado !== false));
  };

  const buscarProdutosOffLine = async (
    filtros,
    setListaProdutos,
    setLoadingAutoComplete,
  ) => {
    const produtos = await ProdutosLocalService.getAll(filtros, {
      modo: "or",
      exatos: ["id"],
      where: { ativado: true },
      orderBy: "codigo",
      limite: 20,
    });
    setLoadingAutoComplete(false);
    setListaProdutos(produtos);
  };

  const buscarProdutosByCodigoOffline = async (
    codigoBarra,
    handleChangeAutocompleteProduto,
    setLoadingAutoComplete,
    quantidadeFind = null,
    valorProduto = null,
    isBalancaPeso = false,
  ) => {
    const produtos = await ProdutosLocalService.getAll(
      { codigoBarra },
      { exatos: ["codigoBarra"], where: { ativado: true }, limite: 1 },
    );
    setLoadingAutoComplete(false);
    if (!produtos?.length) {
      notification.alertaGenericos(
        `Nenhum produto encontrado com o código ${codigoBarra}`,
      );
      return;
    }
    const produtoEncontrado = produtos[0];
    let quantidade = quantidadeFind;
    let valor = valorProduto;
    if (valorProduto && produtoEncontrado.informacao?.precoVenda) {
      if (isBalancaPeso) {
        quantidade = valor;
        valor = valorProduto * produtoEncontrado.informacao.precoVenda;
      } else {
        quantidade = valorProduto / produtoEncontrado.informacao.precoVenda;
      }
    }
    handleChangeAutocompleteProduto(produtoEncontrado, true, quantidade, valor);
  };

  const buscarIniFileInfo = async () => {
    const result = await tefHubService.fetchIniFileInfo();
    setConfiguracoesTef(result?.data);
  };

  const atualizarIniFileInfo = async (body) => {
    const result = await tefHubService.updateIniFileInfo(body);
    if (!result.isAxiosError) {
      setConfiguracoesTef(body);
      notification.sucessoGenericos("Configurações TEF salvas com sucesso");
    } else {
      responseErros(result);
    }
  };

  const onChangeAutocomplete = (name, value) => {
    if (name === "clienteId") {
      setClienteSelecionado(value);
      pdvEntity.setIdentificarCliente(value);
      setVenda(pdvEntity);
    }
    pdvEntity.setHandleChangeAutoComplete(name, value);
    setVenda(pdvEntity);
  };

  const existePagamentoLancado = () =>
    listaPagamentosVenda?.length > 0 ||
    pdvEntity?.nfSaidaPagamentos?.length > 0;

  const bloqueadoPorPagamentoLancado = (acao) => {
    if (!existePagamentoLancado()) return false;
    notification.alertaGenericos(
      `Não é possível ${acao} com pagamento lançado. Estorne os pagamentos (Ctrl + P) para continuar`,
    );
    return true;
  };

  const bloqueadoPorVendaEmAndamento = (acao) => {
    if (!existeVendaEmAndamento()) return false;
    notification.alertaGenericos(
      `Não é possível ${acao} com venda em andamento. Grave a venda ou limpe o carrinho (Ctrl + Alt + C) para continuar`,
    );
    return true;
  };

  function mostrarDialogPermissao(permissao, descricaoPermissao) {
    return new Promise((resolve) => {
      const fecharDialog = (autorizado) => {
        setDialogPermissao((prev) => ({ ...prev, open: false }));
        resolve(autorizado);
      };
      setDialogPermissao({
        open: true,
        permissao,
        descricaoPermissao,
        onValidate: () => fecharDialog(true),
        onClose: () => fecharDialog(false),
      });
    });
  }

  async function validarPermissao(
    permissao,
    descricaoPermissao,
    permissaoPedirSenha,
  ) {
    const temPermissao = permissoesHelper.temPermisao(permissao);
    const pedirSenha =
      Boolean(permissaoPedirSenha) &&
      permissoesHelper.temPermisao(permissaoPedirSenha);
    if (temPermissao && !pedirSenha) return true;
    if (!pedirSenha) {
      notification.alertaGenericos(
        `Você não tem permissão para ${descricaoPermissao}`,
      );
      return false;
    }
    if (dialogPermissao.open) return false;
    return await mostrarDialogPermissao(permissao, descricaoPermissao);
  }

  const validarEstornoPagamento = () =>
    validarPermissao(
      "estornar-pagamento",
      "estornar pagamento",
      "pedir-senha-estornar-pagamento",
    );

  const handleAdicionarProduto = async (produto, item, valorProduto) => {
    if (!produto) {
      return notification.alertaGenericos(
        "Selecione um produto para adicionar",
      );
    }
    if (
      bloqueadoPorPagamentoLancado(
        item?.itemEditado ? "editar produto" : "adicionar produto",
      )
    ) {
      return;
    }
    let listaProdutosVendaTemp = [];
    if (item?.itemEditado) {
      const produtoIndex = listaProdutosVenda.findIndex(
        (produtoVenda) => produtoVenda.id === produto.id,
      );
      const quantidadeItem = normalizarQuantidade(produto, item.quantidade);
      listaProdutosVendaTemp = [
        ...listaProdutosVenda.map((obj, index) => {
          if (index === produtoIndex) {
            return {
              ...obj,
              ...item,
              id: shortid.generate(),
              quantidade: quantidadeItem,
              subtotal: quantidadeItem * item.valor,
            };
          }
          return obj;
        }),
      ];
    } else {
      const nfSaidaItem = new NfSaidaItem(
        item,
        listaProdutosVenda.length,
        operacaoFiscal,
        origensMercadoriasList,
        unidadeList,
      );
      if (nfSaidaItem === null) {
        return notification.alertaGenericos("Produto sem imposto");
      }
      listaProdutosVendaTemp = [
        ...listaProdutosVenda,
        {
          ...item,
          ...nfSaidaItem,
          id: shortid.generate(),
          produto: produto?.descricao,
          quantidade: item?.quantidade ?? 1,
          subtotal: valorProduto ?? item?.valor * (item?.quantidade ?? 1),
        },
      ];
    }
    setListaProdutosVenda(listaProdutosVendaTemp);
    setListaPagamentosVenda([]);
    pdvEntity.setChangePagamentos([]);
    pdvEntity.setChangeItens(null, listaProdutosVendaTemp);
    setVenda(pdvEntity);
    setItem({});
    document.getElementById("produtoId").focus();
    setIsProdutoEdit(false);
    setProduto(null);
    setItem(null);
    setListaProdutos([]);
  };

  const handleEditarProduto = async (id) => {
    if (bloqueadoPorPagamentoLancado("editar produto")) return;
    const autorizado = await validarPermissao(
      "editar-item-carrinho",
      "editar item do carrinho",
    );
    if (!autorizado) return;
    const produto = listaProdutosVenda.find(
      (produtoVenda) => produtoVenda.id === id,
    );
    if (produto) {
      setIsProdutoEdit(true);
    }
    setProduto(produto);
    setItem({
      ...produto,
      itemEditado: true,
    });
  };

  const handleRemoverProduto = async (id) => {
    if (bloqueadoPorPagamentoLancado("excluir produto")) return;
    const autorizado = await validarPermissao(
      "excluir-item-carrinho",
      "excluir item do carrinho",
      "pedir-senha-excluir-item",
    );
    if (!autorizado) return;
    const data = listaProdutosVenda.filter(
      (produtoVenda) => produtoVenda.id !== id,
    );
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir?`,
    );
    if (retornoAlerta.isConfirmed) {
      const itemRemovido = listaProdutosVenda.find(
        (produtoVenda) => produtoVenda.id === id,
      );
      const itemCancelado = new NfSaidaItemCancelado(itemRemovido);
      if (pdvOnLine) {
        await nfSaidaService.cancelarItem(itemCancelado);
      }
      setListaProdutosVenda(data);
      pdvEntity.setChangeItens(null, data);
      setListaPagamentosVenda([]);
      pdvEntity.setChangePagamentos([]);
      setVenda(pdvEntity);
    }
  };

  const noRowsOverlay = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
        }}
      >
        <img src={market} alt="imagem carrinho" style={{ width: "33vh" }} />
      </div>
    );
  };

  const verificaVendaPrazo = () => {
    const isBaixaAutomatica = verificaBaixaAutomatica(venda, meioPagamentoList);
    return !isBaixaAutomatica;
  };

  const validarNfSaida = () => {
    const erro = (mensagem) => {
      notification.alertaGenericos(mensagem);
      setLoading(false);
      return false;
    };
    const isModelo55 = operacaoFiscal?.modeloDocumento === "55";
    const naoEhDevolucao = operacaoFiscal?.finalidade !== "DEVOLUCAO";
    const semEnderecoCliente = !pdvEntity?.nfSaidaEnderecoCliente?.id;
    if (isModelo55 && naoEhDevolucao && semEnderecoCliente) {
      return erro("É necessario cadastro de endereço para salvar");
    }
    const verificarVendaPrazo = verificaVendaPrazo();
    if (verificarVendaPrazo && !venda.clienteId) {
      return erro("É necessário informar cliente para vendas a prazo");
    }
    if (pdvEntity.totalVenda - pdvEntity.totalPagamentos > 0) {
      return erro("É necessário atualizar valor da(s) parcela(s)");
    }
    const limiteUF = limitesVenda.find(
      ({ uf }) => dadosEmpresa.enderecoUF === uf,
    )?.limite;
    if (
      limiteUF &&
      Number(pdvEntity?.totalVenda) > limiteUF &&
      !pdvEntity?.clienteCnpjCpf &&
      operacaoFiscal?.modeloDocumento !== "01"
    ) {
      identificarCliente();
      return erro(
        `Vendas de valor superior a ${formatPrice(limiteUF)} devem identificar cliente.`,
      );
    }
    return true;
  };

  const handleSubmit = async (operacaoPadrao = true) => {
    setLoading(true);
    try {
      if (!operacaoPadrao && !operacaoFiscalSecundaria?.id) {
        notification.alertaGenericos(
          "Operação fiscal secundária não informada",
        );
        return;
      }
      const operacao = operacaoPadrao
        ? operacaoFiscal
        : operacaoFiscalSecundaria;

      if (operacao.modeloDocumento === "01") {
        const tefIntegrado = listaPagamentosVenda.find(
          ({ meioPagamentoSelecionado }) =>
            meioPagamentoSelecionado.tefIntegrado,
        );
        if (tefIntegrado) {
          notification.alertaGenericos(
            "Não é permitido operação não fiscal com pagamento via TEF/POS",
          );
          return;
        }
      }
      pdvEntity.setOperacaoFiscal(operacao);
      pdvEntity.setVendedorObrigatorioPermissao(
        permissoesHelper.temPermisao("pdv-vendedor-obrigatorio"),
      );
      pdvEntity.setDataSaida(new Date());
      await nfSaidaValidatorService.validate(pdvEntity, {
        abortEarly: false,
      });
      pdvEntity.setChangePagamentos(listaPagamentosVenda);
      if (!validarNfSaida()) return;
      pdvEntity.arendondarQuantidadesItens();
      if (pdvOnLine) {
        await cadastrarNfSaidaOnline(operacao);
      } else {
        await cadastrarNfSaidaOffline(operacao);
      }
    } catch (err) {
      if (err?.inner?.[0]?.path === "nfSaidaPagamentos") {
        await processarPagamentos();
      }
      inputErros.set(err);
    } finally {
      setLoading(false);
    }
  };

  async function cadastrarNfSaidaOnline(operacao) {
    const response = await nfSaidaService.cadastrar(pdvEntity);
    if (response.isAxiosError) {
      responseErros(response);
      return;
    }
    marcarVendaGravada();
    notification.cadastroSucesso();
    if (operacao?.modeloDocumento !== "01") {
      await emitirAposCadastro(response.data);
      return;
    }
    await buscarDanfeSecundaria(response.data, pdvEntity.troco).then(() =>
      handleInitPdv(),
    );
  }

  async function buscarConfiguracaoPdvOfflinePorOperacao(operacaoFiscalId) {
    const configuracoesPdvOffline = await PdvOfflineLocalService.getAll();
    return configuracoesPdvOffline.find(
      (item) => Number(item.fisOperacaoFiscalId) === Number(operacaoFiscalId),
    );
  }

  async function atualizarNumeroDocumentoPdvOffline(
    configuracaoPdvOffline,
    numeroDocumento,
  ) {
    const documentoAtualizado = {
      ...configuracaoPdvOffline,
      numeroDocumento: String(numeroDocumento),
    };
    return await PdvOfflineLocalService.atualizar(documentoAtualizado);
  }

  async function abrirDanfeSecundariaOffline() {
    try {
      setLoading(true);
      const dadosOffline = sessionService.getDadosOffline();
      const base64Pdf = await generateDanfeNfceSecundaria({
        pdvEntity,
        dadosEmpresa,
        meioPagamentoList,
        imagemLogoBase64: dadosOffline?.imagemLogoBase64,
      });
      if (configuracoes?.impressaoDiretaPdv) {
        print(base64Pdf);
      } else {
        await openAbaDanfeBase64(base64Pdf);
      }
    } catch (error) {
      notification.erroGenericos(
        "Erro ao gerar DANFE secundária para impressão.",
      );
    } finally {
      setLoading(false);
    }
  }

  async function abrirDanfeContingenciaOffline() {
    try {
      setLoading(true);
      pdvEntity.gerarChaveAcesso(dadosEmpresa);
      const dadosOffline = sessionService.getDadosOffline();
      const base64Pdf = await generateDanfeNfceContigencia({
        pdvEntity,
        dadosEmpresa,
        imagemLogoBase64: dadosOffline?.imagemLogoBase64,
      });
      if (configuracoes?.impressaoDiretaPdv) {
        print(base64Pdf);
      } else {
        await openAbaDanfeBase64(base64Pdf);
      }
    } catch (error) {
      notification.erroGenericos(
        "Erro ao gerar DANFE de contingência para impressão.",
      );
    } finally {
      setLoading(false);
    }
  }

  async function cadastrarNfSaidaOffline(operacao) {
    const configuracaoPdvOffline =
      await buscarConfiguracaoPdvOfflinePorOperacao(operacao?.id);
    if (!configuracaoPdvOffline) {
      notification.alertaGenericos(
        "Configuração offline da operação fiscal não encontrada",
      );
      return;
    }
    const proximoNumeroDocumento =
      Number(configuracaoPdvOffline.numeroDocumento || 0) + 1;
    pdvEntity.serieDocumento = configuracaoPdvOffline.serie;
    pdvEntity.numeroDocumento = String(proximoNumeroDocumento);
    pdvEntity.setTimeStamp();
    const response = await NfSaidaLocalService.cadastrar(pdvEntity);
    if (!response.success) {
      notification.erroInternoServidor();
      return;
    }
    marcarVendaGravada();
    const atualizacaoNumero = await atualizarNumeroDocumentoPdvOffline(
      configuracaoPdvOffline,
      proximoNumeroDocumento,
    );
    if (!atualizacaoNumero.success) {
      notification.erroInternoServidor();
      return;
    }
    notification.cadastroSucesso();
    storageHelper.setLocal("nf-saidas-sincronizacao-pendente", true);
    const confirmacao = await notification.confirmacaoGenericos({
      title: "Documento cadastrado com sucesso",
      text: `#${proximoNumeroDocumento}`,
      icon: "success",
      confirmButtonText: "IMPRIMIR",
      cancelButtonText: "FECHAR",
      showCancelButton: true,
    });
    if (confirmacao.isConfirmed) {
      if (operacao?.modeloDocumento !== "01") {
        await abrirDanfeContingenciaOffline();
      } else {
        await abrirDanfeSecundariaOffline();
      }
    }
    handleInitPdv();
  }

  async function imprimirComprovanteDebito() {
    const pagamentosAprazo = venda.nfSaidaPagamentos.filter(
      (pagamento) =>
        pagamento.meioPagamentoSelecionado.imprimirComprovanteDebito == true,
    );
    if (pagamentosAprazo.length === 0) {
      return;
    }
    try {
      setLoading(true);
      const base64Pdf = await generateComprovanteDebito({
        pdvEntity: venda,
        dadosEmpresa,
        pagamentosAprazo,
      });
      print(base64Pdf, true);
    } catch (error) {
      notification.erroGenericos(
        "Erro ao gerar comprovante de débito para impressão.",
      );
    } finally {
      setLoading(false);
    }
  }

  async function buscarDanfeSecundaria(data, troco = 0) {
    try {
      setLoading(true);
      const result = await nfSaidaService.getDanfeSecundaria(
        data.id,
        dadosEmpresa,
        { troco },
      );
      if (result.isAxiosError) {
        responseErros(result);
        return;
      }
      const danfe = result.data;
      if (!configuracoes?.impressaoDiretaPdv) {
        openAbaDanfeBase64(danfe);
        return;
      }
      if (!configuracoes?.confirmacaoImpressaoPdv) {
        print(danfe);
        return;
      }
      const confirmacao = await notification.confirmacaoGenericos({
        title: "Documento cadastrado com sucesso",
        text: `#${data.numeroDocumento}`,
        icon: "success",
        confirmButtonText: "IMPRIMIR",
        cancelButtonText: "FECHAR",
        showCancelButton: true,
      });
      if (confirmacao.isConfirmed) {
        print(danfe);
      }
    } finally {
      setLoading(false);
    }
  }

  async function buscarDanfeContingencia(idNfSaida) {
    try {
      setLoading(true);
      pdvEntity.gerarChaveAcesso(dadosEmpresa);
      const result = await nfSaidaService.getDanfeContingencia(
        idNfSaida,
        empresaImpressao,
        {
          qrCode: pdvEntity.urlChave,
        },
      );
      if (result.isAxiosError) {
        responseErros(result);
        return;
      }
      const danfe = result.data;
      if (configuracoes?.impressaoDiretaPdv) {
        print(danfe);
      } else {
        openAbaDanfeBase64(danfe);
      }
    } finally {
      setLoading(false);
    }
  }

  const emitirAposCadastro = async (data) => {
    const confirmacaoAlerta = await notification.confirmacaoGenericos({
      title: "Documento cadastrado com sucesso",
      text: `#${data.numeroDocumento}`,
      icon: "success",
      confirmButtonText: "EMITIR",
      cancelButtonText: "FECHAR",
      showCancelButton: true,
    });
    if (confirmacaoAlerta.isConfirmed) {
      setLoading(true);
      try {
        const result = await emitirNfSaida(data.id);
        if (result.success && !result.impressa) {
          if (result.data?.status === "CONTINGENCIA") {
            await buscarDanfeContingencia(data.id);
          } else {
            await buscarDanfe(data.id);
          }
        }
      } catch (error) {
        notification.erroGenericos("Erro no processo de emissão");
      } finally {
        setLoading(false);
        handleInitPdv();
      }
    } else handleInitPdv();
  };

  async function buscarDanfe(nfSaidaId) {
    setLoading(true);
    const result = await nfSaidaService.getDanfe(nfSaidaId);
    setLoading(false);
    if (!result.isAxiosError) {
      if (configuracoes?.impressaoDiretaPdv) {
        print(result.data);
      } else {
        openAbaDanfeBase64(result.data);
      }
    } else {
      responseErros(result);
    }
  }

  async function openAbaDanfeBase64(base64Pdf) {
    try {
      const response = await fetch(`data:application/pdf;base64,${base64Pdf}`);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const pdfWindow = window.open(url, "_blank");
      if (!pdfWindow) {
        notification.alertaGenericos(
          "Popup bloqueado - por favor permita popups para este site",
        );
      }

      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (error) {
      console.error("Erro ao abrir PDF:", error);
      throw error;
    }
  }

  async function print(base64Pdf, ignorarComprovanteDebito = false) {
    setLoading(true);
    try {
      if (!base64Pdf) {
        notification.erroGenericos("Erro ao gerar imagem para impressão.");
        return;
      }
      if (!ignorarComprovanteDebito) {
        await imprimirComprovanteDebito();
      }
      const body = {
        base64Pdf,
        printerName: configuracoes?.impressoraTermica || null,
      };
      const resultImpressao = await impressoraService.imprimirTermicaPdf(body);
      if (!resultImpressao.isAxiosError) {
        notification.sucessoGenericos("Impressão realizada com sucesso!");
      } else {
        if (resultImpressao.response?.status === 404) {
          throw new Error("404 - Not Found");
        }
        responseErros(resultImpressao);
      }
    } catch (error) {
      console.error("Erro na impressão:", error);
      notification.erroGenericos("Erro ao realizar a impressão.");
    } finally {
      setLoading(false);
    }
  }

  const alertaRetornoEmitirNota = async (response, idNfSaida = null) => {
    if (!response.isAxiosError) {
      if (response.data?.status === "CONTINGENCIA") {
        notification.alertaGenericos(
          "Nota emitida em CONTINGÊNCIA — SEFAZ indisponível no momento. Imprima a DANFE em contingência e transmita a nota assim que o serviço da SEFAZ for restabelecido.",
        );
      } else {
        notification.sucessoGenericos("Nota Emitida com sucesso");
      }
      return { success: true, data: response.data };
    }

    const res = response.response?.data;
    let message = null;
    if (res?.response?.retornoNf?.protNFe) {
      message = res.response.retornoNf.protNFe.xMotivo;
    } else message = res?.response?.retornoNf?.message;
    const errorMessage = message || "Erro desconhecido na emissão";

    const confirmacaoErro = await notification.confirmacaoGenericos({
      title: "Erro de emissão de documento",
      text: errorMessage,
      icon: "warning",
      confirmButtonText: "EMITIR EM CONTINGÊNCIA",
      cancelButtonText: "FECHAR",
      showCancelButton: true,
      padding: "1rem",
      width: "35rem",
    });

    if (confirmacaoErro.isConfirmed) {
      return await emitirContingencia(idNfSaida);
    }
    return { success: false };
  };

  const emitirContingencia = async (idNfSaida) => {
    try {
      const response =
        await nfSaidaService.emitirNotaFiscalPendenciaContingencia(idNfSaida);

      if (!response.isAxiosError) {
        notification.sucessoGenericos(
          "Nota emitida em contingência com sucesso",
        );
        if (configuracoes?.visualizarImpressaoEmissao) {
          await buscarDanfeContingencia(idNfSaida);
        }
        return { success: true, impressa: true, data: response.data };
      } else {
        responseErros(response);
      }
      return { success: false };
    } catch (error) {
      notification.erroGenericos("Erro ao processar contingência");
      return { success: false };
    }
  };

  const emitirNfSaida = async (idNfSaida) => {
    try {
      const response = await nfSaidaService.emitirNotaFiscal(idNfSaida);
      return await alertaRetornoEmitirNota(response, idNfSaida);
    } catch (error) {
      notification.erroGenericos("Erro na comunicação com o servidor");
      return { success: false };
    }
  };

  const buscarPessoaVendedor = async (filtros) => {
    const filtro = {
      ...filtros,
      nonPaginated: true,
      vendedor: true,
    };
    const usuario = await sessionService.getUsuario();
    const result = await colaboradorService.getAll(filtro);
    if (!result.isAxiosError) {
      setVendedorList(
        result.data
          .filter((vendedor) => vendedor?.pessoa)
          .map(({ pessoa, ...vendedor }) => ({
            ...vendedor,
            ...pessoa,
          })),
      );
      const colaboradorVendedorUsuario = result.data.find(
        (colaborador) => colaborador.usuarioId === usuario?.id,
      );
      if (colaboradorVendedorUsuario) {
        if (!pdvEntity.vendedorId) {
          pdvEntity.setColaboradorVendedorUsuario(
            colaboradorVendedorUsuario.pessoa.id,
            colaboradorVendedorUsuario.bancoCaixaId,
            permissoesHelper.temPermisao("utilizar-caixa-colaborador"),
          );
        }
        setColaboradorVendedor(colaboradorVendedorUsuario);
        setVenda(pdvEntity);
      }
    } else {
      responseErros(result);
    }
  };

  const buscarPessoaVendedorOffLine = async () => {
    const usuario = await sessionService.getUsuario();
    const colaboradores = await ColaboradoresLocalService.getAll(
      {},
      { where: { vendedor: true } },
    );
    setVendedorList(
      colaboradores
        .filter(
          (vendedor) => vendedor?.pessoa && vendedor.pessoa.ativado !== false,
        )
        .map(({ pessoa, ...vendedor }) => ({
          ...vendedor,
          ...pessoa,
        })),
    );
    const colaboradorVendedorUsuario = colaboradores.find(
      (colaborador) => colaborador.usuarioId === usuario?.id,
    );
    if (colaboradorVendedorUsuario) {
      if (!pdvEntity.vendedorId) {
        pdvEntity.setColaboradorVendedorUsuario(
          colaboradorVendedorUsuario.pessoa.id,
          colaboradorVendedorUsuario.bancoCaixaId,
          permissoesHelper.temPermisao("utilizar-caixa-colaborador"),
        );
      }
      setColaboradorVendedor(colaboradorVendedorUsuario);
      setVenda(pdvEntity);
    }
  };

  async function processarPagamentos(pagamento) {
    if (pdvEntity.totalPagamentos >= pdvEntity.totalVenda) {
      notification.alertaGenericos("Valor total pago");
      return;
    }
    if (!listaProdutosVenda?.length) {
      notification.alertaGenericos("Insira um produto");
      return;
    }
    if (!listaNotasCredito.length) {
      return selecionarPagamento(pagamento);
    }
    const confirmacaoAlerta = await notification.confirmacaoGenericos({
      title: "Cliente com crédito",
      text: `Deseja utilizar nesta compra?`,
      icon: "warning",
      confirmButtonText: "SIM",
      cancelButtonText: "NÃO",
      showCancelButton: true,
    });
    if (confirmacaoAlerta.isConfirmed) {
      setOpenNotasCreditoDialog(true);
    } else {
      selecionarPagamento(pagamento);
    }
  }

  async function handleInitPdv() {
    pdvEntity = novaNfSaidaPdv();
    vendaGravadaRef.current = false;
    removerVendaEmAndamento();
    setVenda(pdvEntity);
    if (pdvOnLine) {
      await buscarPessoaVendedor();
      await buscarConfiguracao();
    }
    setClienteSelecionado(null);
    setListaProdutosVenda([]);
    setListaPagamentosVenda([]);
    setLoading(false);
    document.getElementById("produtoId").focus();
  }

  async function buscarDadosIniciais(onLine) {
    document.getElementById("produtoId").classList.add("mousetrap");
    const configuracoesEmpresa = await buscarConfiguracao();
    if (onLine === false) {
      await buscarDadosIniciaisOffLine(configuracoesEmpresa);
    } else {
      await buscarDadosIniciaisOnLine(configuracoesEmpresa);
    }
    document?.getElementById("produtoId")?.focus();
  }

  async function buscarDadosIniciaisOffLine(configuracoesEmpresa) {
    if (dadosEmpresa?.id) {
      const meiosPagamento = await buscarMeiosPagamentosOffLine();
      if (meiosPagamento.length === 0) {
        const token = storageHelper.getLocal("token");
        sessionService.setPdvOnlineStatus(true);
        if (token && token !== "offline-token") {
          setPdvOnLine(true);
          await buscarDadosIniciaisOnLine(configuracoesEmpresa);
        }
        return;
      }
      await buscarPessoaVendedorOffLine();
      preencherListaPagamentoPadrao(configuracoesEmpresa, meiosPagamento);
      buscarUnidadesComerciaisOffLine();
      buscarOperacoesFiscaisOffLine(configuracoesEmpresa);
      buscarCondicoesPagamentosOffLine();
      buscarOrigensMercadoriaOffLine();
      buscarNfSaidaOffLine();
    }
  }

  async function buscarDadosIniciaisOnLine(configuracoesEmpresa) {
    const meiosPagamento = await buscarMeiosPagamentos();
    if (!meiosPagamento) return;
    await buscarPessoaVendedor();
    preencherListaPagamentoPadrao(configuracoesEmpresa, meiosPagamento);
    buscarUnidadesComerciais();
    buscarOperacoesFiscais(configuracoesEmpresa);
    buscarCondicoesPagamentos();
    buscarOrigensMercadoria();
    buscarNfSaida();
    //olhar nessecidade de trazer os dados offline abaixo
    buscarBancoCaixaResponsavel();
    if (dadosEmpresa.moduloTef) {
      buscarIniFileInfo();
    }
  }

  async function preencherListaPagamentoPadrao(
    configuracoesEmpresa,
    meiosPagamento,
  ) {
    const listaPagamentos = getListaPagamentoPadrao(
      configuracoesEmpresa,
      meiosPagamento,
    );
    setListaPagamentoPadrao(listaPagamentos);
    const atalhosPagamentos = listaPagamentos.map((pagamento, index) => ({
      atalho: `Ctrl + Alt + ${index + 1}`,
      nome: pagamento.descricao,
    }));
    if (!atalhos.includes(atalhosPagamentos)) {
      setAtalhos((prevState) => [...prevState, ...atalhosPagamentos]);
    }
  }

  async function limparPdvAtalho() {
    if (!pdvEntity.nfSaidaItens?.length) return;
    if (bloqueadoPorPagamentoLancado("limpar o carrinho")) return;
    const autorizado = await validarPermissao(
      "limpar-carrinho",
      "limpar o carrinho",
    );
    if (!autorizado) return;
    const confirmacaoAlerta = await notification.confirmacaoGenericos({
      title: "Deseja limpar carrinho?",
      icon: "warning",
      confirmButtonText: "SIM",
      cancelButtonText: "NÃO",
      showCancelButton: true,
    });
    if (confirmacaoAlerta.isConfirmed) {
      setLoading(true);
      if (pdvOnLine) {
        await Promise.all(
          listaProdutosVenda.map((item) =>
            nfSaidaService.cancelarItem(new NfSaidaItemCancelado(item)),
          ),
        );
      }
      await handleInitPdv();
      setLoading(false);
    }
  }

  const selecionarPagamento = (pagamento) => {
    setPagamentoSelecionado(pagamento);
    if (pagamento?.condicoesPagamento.length === 1) {
      setCondicaoSelecionada(pagamento.condicoesPagamento[0]);
    }
    setOpenDialogPagamentos(true);
  };

  if (pdvAbertoOutraAba) {
    return (
      <ThemeProvider theme={lightTheme}>
        <Box className="d-flex flex-column align-items-center justify-content-center text-center vh-100 gap-2 px-4">
          <i className="ph-fill ph-warning" style={{ fontSize: 48 }}></i>
          <Typography variant="h6">
            O PDV já está aberto em outra aba ou janela deste navegador
          </Typography>
          <Typography variant="body2">
            Continue a venda por lá ou feche a outra aba e recarregue esta
            página.
          </Typography>
        </Box>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={pdvOnLine ? lightTheme : offlineTheme}>
      <Box className="box w-100">
        <CabecalhoPdv
          listaProdutos={listaProdutos}
          setListaProdutos={setListaProdutos}
          handleLogout={handleLogout}
          dadosUsuario={dadosUsuario}
          dadosEmpresa={dadosEmpresa}
          setProduto={setProduto}
          permitirVendaEstoqueNegativo={configuracoes?.vendaEstoqueNegativo}
          unidadeList={unidadeList}
          origensMercadoriasList={origensMercadoriasList}
          setItem={setItem}
          setUserLog={setUserLog}
          handleAdicionarProduto={handleAdicionarProduto}
          setOpenDialogOperacoesCaixa={setOpenDialogOperacoesCaixa}
          setOpenImportarPedidoDialog={setOpenImportarPedidoDialog}
          setOpenDialogHistoricoNfSaida={setOpenDialogHistoricoNfSaida}
          limparPdvAtalho={limparPdvAtalho}
          pdvOnLine={pdvOnLine}
          setPdvOnLine={setPdvOnLine}
          buscarDadosIniciais={buscarDadosIniciais}
          setListaProdutosSimilares={setListaProdutosSimilares}
          buscarProdutosOffLine={buscarProdutosOffLine}
          buscarProdutosByCodigoOffline={buscarProdutosByCodigoOffline}
          nfSaidasSincronizacaoPendentes={nfSaidasSincronizacaoPendentes}
          configuracoesTef={configuracoesTef}
          atualizarIniFileInfo={atualizarIniFileInfo}
          anchorEmpresas={anchorEmpresas}
          setAnchorEmpresas={setAnchorEmpresas}
          tefConnection={tefConnection}
          dadosMenuTef={dadosMenuTef}
          setDadosMenuTef={setDadosMenuTef}
          abrirDialogAdministracaoTef={abrirDialogAdministracaoTef}
          openDialogAdministracaoTef={openDialogAdministracaoTef}
          setOpenDialogAdministracaoTef={setOpenDialogAdministracaoTef}
          bloqueadoPorVendaEmAndamento={bloqueadoPorVendaEmAndamento}
        />
        {!pdvOnLine && (
          <div className="faixa-modo-offline">
            MODO OFFLINE - VENDAS ARMAZENADAS LOCALMENTE E SINCRONIZADAS AO
            RECONECTAR
          </div>
        )}
        <Box>
          <Grid container className="h-100">
            <Grid item xs={6} className="px-5 py-4">
              {produto ? (
                <PdvProdutoView
                  produto={produto}
                  setProduto={setProduto}
                  item={item}
                  setItem={setItem}
                  userLog={userLog}
                  handleAdicionarProduto={handleAdicionarProduto}
                  isProdutoEdit={isProdutoEdit}
                  listaProdutosSimilares={listaProdutosSimilares}
                  setListaProdutosSimilares={setListaProdutosSimilares}
                  unidadeList={unidadeList}
                  origensMercadoriasList={origensMercadoriasList}
                  permissoesHelper={permissoesHelper}
                />
              ) : (
                <PdvClienteView
                  venda={venda}
                  setVenda={setVenda}
                  setOperacaoFiscal={setOperacaoFiscal}
                  operacaoFiscalList={operacaoFiscalList}
                  meioPagamentoList={meioPagamentoList}
                  condicaoPagamentoList={condicaoPagamentoList}
                  vendedorList={vendedorList}
                  clienteSelecionado={clienteSelecionado}
                  setClienteSelecionado={setClienteSelecionado}
                  setOpenDialogClienteAvulso={setOpenDialogIdentificarCliente}
                  setOpenDialogInformacaoComplementar={
                    setOpenDialogInformacaoComplementar
                  }
                  onChangeAutocomplete={onChangeAutocomplete}
                  inputErros={inputErros}
                  setInputErro={setInputErro}
                  openDialogPagamentos={openDialogPagamentos}
                  setOpenDialogPagamentos={setOpenDialogPagamentos}
                  listaPagamentosVenda={listaPagamentosVenda}
                  setListaPagamentosVenda={setListaPagamentosVenda}
                  listaProdutosVenda={listaProdutosVenda}
                  setListaProdutosVenda={setListaProdutosVenda}
                  openDialogListaPagamentos={openDialogListaPagamentos}
                  setOpenDialogListaPagamentos={setOpenDialogListaPagamentos}
                  pagamentoSelecionado={pagamentoSelecionado}
                  setPagamentoSelecionado={setPagamentoSelecionado}
                  condicaoSelecionada={condicaoSelecionada}
                  setCondicaoSelecionada={setCondicaoSelecionada}
                  processarPagamentos={processarPagamentos}
                  vendedorObrigatorio={permissoesHelper.temPermisao(
                    "pdv-vendedor-obrigatorio",
                  )}
                  colaboradorVendedor={colaboradorVendedor}
                  listaPagamentoPadrao={listaPagamentoPadrao}
                  pdvEntity={pdvEntity}
                  permissaoAcrescimo={permissoesHelper.temPermisao(
                    "aplicar-acrescimo",
                  )}
                  permissaoDesconto={permissoesHelper.temPermisao(
                    "aplicar-desconto",
                  )}
                  validarEstornoPagamento={validarEstornoPagamento}
                  bloqueadoPorPagamentoLancado={bloqueadoPorPagamentoLancado}
                />
              )}
            </Grid>
            <Grid item xs={6} className="grid-content-pdv">
              <div
                id="produtos-table"
                className="d-flex flex-column justify-content-between border h-100"
              >
                <Box className="table-overflow-produtos">
                  <DataGrid
                    ref={gridRef}
                    apiRef={apiRef}
                    rows={listaProdutosVenda}
                    columns={dadosProdutosColunas}
                    rowCount={listaProdutosVenda?.length}
                    paginationMode="client"
                    disableRowSelectionOnClick
                    slots={{
                      noRowsOverlay: noRowsOverlay,
                    }}
                    getRowHeight={() => "auto"}
                    disableColumnMenu
                    hideFooter
                    hideFooterPagination
                    hideFooterSelectedRowCount
                  />
                </Box>
                <PdvTotalizadores venda={venda} handleSubmit={handleSubmit} />
              </div>
            </Grid>
          </Grid>
        </Box>
        <IdentificarClienteDialog
          open={openDialogIdentificarCliente}
          setOpen={setOpenDialogIdentificarCliente}
          clienteList={clienteList}
          setClienteList={setClienteList}
          setClienteSelecionado={setClienteSelecionado}
          setListaNotasCredito={setListaNotasCredito}
          setVenda={setVenda}
          pdvEntity={pdvEntity}
          buscarClienteOffLine={buscarClienteOffLine}
          pdvOnLine={pdvOnLine}
        />
        <InformacaoComplementarDialog
          open={openDialogInformacaoComplementar}
          setOpen={setOpenDialogInformacaoComplementar}
          venda={venda}
          setVenda={setVenda}
          pdvEntity={pdvEntity}
        />
        <OperacoesCaixaDialog
          openDialogOperacoesCaixa={openDialogOperacoesCaixa}
          setOpenDialogOperacoesCaixa={setOpenDialogOperacoesCaixa}
          dataAberturaCaixa={dataAberturaCaixa}
          bancoCaixa={bancoCaixa}
          setBancoCaixa={setBancoCaixa}
          setListaProdutosVenda={setListaProdutosVenda}
          meioPagamentoList={meioPagamentoList}
          validarToken={validarToken}
          setLoading={setLoading}
          bloqueadoPorVendaEmAndamento={bloqueadoPorVendaEmAndamento}
        />
        <HistoricoNfSaidaDialog
          open={openDialogHistoricoNfSaida}
          handleCloseDialog={() => setOpenDialogHistoricoNfSaida(false)}
          operacaoFiscalList={operacaoFiscalList}
          listaNfSaida={listaNfSaida}
          nfSaidaRowCount={nfSaidaRowCount}
          clienteList={clienteList}
          buscarNfSaida={buscarNfSaida}
          pdvOnLine={pdvOnLine}
        />
        <ImportarPedidoPdvDialog
          openImportarPedidoDialog={openImportarPedidoDialog}
          setOpenImportarPedidoDialog={setOpenImportarPedidoDialog}
          setListaProdutosVenda={setListaProdutosVenda}
          setListaPagamentosVenda={setListaPagamentosVenda}
          operacaoFiscal={operacaoFiscal}
          meioPagamentoList={meioPagamentoList}
          setMeioPagamentoList={setMeioPagamentoList}
          operacaoFiscalList={operacaoFiscalList}
          setOperacaoFiscalList={setOperacaoFiscalList}
          setClienteSelecionado={setClienteSelecionado}
          pdvEntity={pdvEntity}
          setVenda={setVenda}
        />
        <ConfiguracoesBalancaDialog
          open={openConfiguracaoBalancaDialog}
          setOpen={setOpenConfiguracaoBalancaDialog}
        />
        <AtalhosDialog
          open={openAtalhosDialog}
          setOpen={setOpenAtalhosDialog}
          atalhos={atalhos}
        />
        <NotasCreditoDialog
          open={openNotasCreditoDialog}
          setOpen={setOpenNotasCreditoDialog}
          listaNotasCredito={listaNotasCredito}
          setListaNotasCredito={setListaNotasCredito}
          notasCredito={notasCredito}
          setNotasCredito={setNotasCredito}
          setVenda={setVenda}
          meioPagamentoCredito={meioPagamentoCredito}
          listaPagamentosVenda={listaPagamentosVenda}
          setListaPagamentosVenda={setListaPagamentosVenda}
          pdvEntity={pdvEntity}
        />
        <SincronizacaoInicialDialog
          open={openDialogSincronizacaoInicial}
          tempoRestante={tempoRestanteSincronizacao}
        />
        <NomePdvOfflineDialog
          openDialogNomePdvOffline={openDialogNomePdvOffline}
          setOpenDialogNomePdvOffline={setOpenDialogNomePdvOffline}
          setLoading={setLoading}
          startSincronizacaoInicialOffline={startSincronizacaoInicialOffline}
        />
        <ValidarPermissaoDialog
          dialog={dialogPermissao}
          pdvOnLine={pdvOnLine}
        />
        {/*<BotaoImpressaoWeb
          LayoutImpressao={
            impressaoFiscal ? (
              <ModeloNfce data={dadosImpressao} empresa={dadosEmpresa} />
            ) : (
              <ModeloNfceSecundaria
                data={dadosImpressao}
                meioPagamentoList={meioPagamentoList}
                empresa={dadosEmpresa}
              />
            )
          }
        />*/}
        <Loading loading={loading} />
      </Box>
    </ThemeProvider>
  );
};

export default PdvView;
